import { render, staticRenderFns } from "./AllowNotificationsBanner.vue?vue&type=template&id=321b2500&scoped=true"
import script from "./AllowNotificationsBanner.vue?vue&type=script&lang=js"
export * from "./AllowNotificationsBanner.vue?vue&type=script&lang=js"
import style0 from "./AllowNotificationsBanner.vue?vue&type=style&index=0&id=321b2500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321b2500",
  null
  
)

export default component.exports